<template>
  <div class="box" style="position: relative;">
    <div style="width:100%;height:100;" class="wx-load-c" v-show="wxShow">
      <p style="text-align: right;">
        <Icon type="ios-close" style="margin: 20px;font-size: 30px;cursor: pointer;" @click="wxClose"/>
      </p>
      <div id="login_container"></div>
    </div>
    <div class="logo">
      <ul style="width: 484px;margin: 155px auto 0;">
        <li><a href="index.html"><img src="../../assets/images/logo_bak.png" alt=""></a></li>
        <li style=" margin-top:32px; line-height: 90px; font-size: 64px;color: #FFFFFF;letter-spacing: 5.12px;">打造视频梦工厂</li>
        <li style="margin-top: 15px; line-height:50px; font-size: 36px;color: #FFFFFF;letter-spacing: 4.8px;">懂视频·更懂你</li>
      </ul>
    </div>
    <div class="reg-from">
      <div style="padding:40px 0">
        <a href="index.html">
          <img style="width:170px;margin: 0 auto;" src="../../assets/images/logo3.png" alt="">
        </a>
      </div>
      <!-- 登录 -->
      <div class="from-box" :class="{'op': op === 1}"v-if="op === 0 && wxBand == false">
        <input type="text" placeholder="请输入手机号" v-on:blur="signPhone()" v-model="sign.phone">
        <p class="from-warning" :class="{'op1': op2 === true}">*请填写正确的手机号</p>
        <input type="password" placeholder="请输入密码" v-if="!dx"  v-model="sign.psd" v-on:blur="signPsd()">
        <p class="from-warning" v-if="!dx" :class="{'op1': op4 === true}">*密码错误</p>
        <p v-if="dx">
          <input type="text" placeholder="请输入验证码" class="yzm-ipt" v-model="sign.psd">
          <span class="get-yzm" @click="signYzm()" v-show="show2">{{yzm2}}</span>
          <span class="get-yzm" v-show="!show2">{{count2}}s</span>
        </p>
        <p class="from-warning" v-if="dx">*验证码错误</p>
        <p style="height: 20px;">
          <Checkbox v-if="!dx">记住密码</Checkbox>
          <span style="float: right;color: #5C8DDE;cursor: pointer" @click="dxFrom()">{{txt}}</span>
        </p>
        <p style="padding: 20px 0;">
          <button class="btn-sign" @click="signIn()">登录</button>
        </p>
        <p style="text-align: center;display:none;">or</p>
        <p style="text-align: center;font-size: 14px;color: #323030;opacity: 0.6;padding: 10px 0;">第三方登录</p>
        <ul style="text-align: center;" class="other-sign">
          <li @click="wxLoad()">
            <a href="">

            </a>
          </li>
          <li style="display:none;">
            <a href="">

            </a>
          </li>
          <li style="display:none;">
            <a href="">

            </a>
          </li>
        </ul>
      </div>
      <!-- 注册 -->
      <div class="from-box" :class="{'op': op !== 1}" v-if="op === 1 && wxBand == false">
        <input type="text" placeholder="请输入昵称" v-model="reg.nickName" v-on:blur="regNC()">
        <p class="from-warning" :class="{'op1': op1 === true}">*请不要输入特殊字符或者为空</p>
        <input type="text" placeholder="请输入手机号" v-model="reg.phone">
        <p class="from-warning" :class="{'op1': op2 === true}">*请填写正确的手机号</p>
        <p v-if="op === 1">
          <input type="text" placeholder="请输入验证码" class="yzm-ipt" v-model="reg.code">
          <span class="get-yzm" @click="getYzm()" v-show="show1">{{yzm1}}</span>
          <span class="get-yzm" v-show="!show1">{{count1}}s</span>
        </p>
        <p class="from-warning">*验证码错误</p>
        <input type="password" placeholder="请输入密码" v-model="reg.psd" v-on:blur="regPsd()">
        <p class="from-warning" :class="{'op1': op4 === true}">*密码格式错误,请输入6-21位字母加数字密码</p>
        <p style="height: 20px;padding-top: 10px;">
          <Checkbox v-model="agr">已阅读并接受 <a href="agreement.html" style="color: #5C8DDE;">《趣编网服务协议》</a><a href="policy.html" style="color: #5C8DDE;">《趣编网隐私政策》</a></Checkbox>
        </p>
        <p style="padding: 20px 0 0px 0">
          <button class="btn-sign" @click="regist()">注册</button>
        </p>
      </div>
      <!-- 绑定第三方 -->
      <div class="from-box" v-if="wxBand">
        <h2>绑定趣编网账号</h2>
        <p style="font-size: 12px;color: #424753;text-align: center;line-height: 20px;margin:12px 0 35px;">登录已有账号，与你现在登录的微信绑定。绑定后，可以使用微信账号或手机号码登录。</p>
        <input type="text" placeholder="请输入手机号" v-model="band.phone">
        <p class="from-warning" :class="{'op1': op2 === true}">*请填写正确的手机号</p>
        <p>
          <input type="text" placeholder="请输入验证码" class="yzm-ipt" v-model="band.code">
          <span class="get-yzm" @click="getBandYzm2()" v-show="show3">{{yzm3}}</span>
          <span class="get-yzm" v-show="!show3">{{count3}}s</span>
        </p>
        <p style="padding: 20px 0 20px 0">
          <button class="btn-sign" @click="goBand()">绑定</button>
        </p>
      </div>
      <ul>
        <li style="font-size: 16px;" v-for="item,index in regList" @click="liClick(index)" v-if="cur !== index" :class="{'li-active' : cur === index}">{{item.name}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import "@/assets/js/common";
import $ from "jquery";
import { apiReg } from "@/fetch/api.js";
import Util from "@/util/util.js";
export default {
  name: "register",
  data() {
    return {
      wxBand: false,
      wxShow: false,
      regList: [
        {
          name: "已有账号？去登录",
          value: "sign"
        },
        {
          name: "没有账号？去注册",
          value: "reg"
        }
      ],
      cur: 0,
      op: 0,
      op1: false,
      op2: false,
      op4: false,
      txt: "短信快捷登录",
      dx: false,
      yzm2: "获取验证码",
      yzm1: "获取验证码",
      yzm3: "获取验证码",
      count1: "",
      count2: "",
      count3: "",
      timer1: null,
      timer2: null,
      timer3: null,
      show1: true,
      show2: true,
      show3: true,
      reg: {},
      agr: false,
      sign: {},
      type: 1,
      band:{
        phone:'',
        code:''
      }
    };
  },
  methods: {
    wxClose(){
      this.wxShow = false
      location.reload();
    },
    wxLoad(){
      this.wxShow = true;
    },
    liClick(index) {
      this.cur = index;
      console.log(this.cur);
      if (this.cur == 1) {
        this.op = 1;
        this.op1 = false;
        this.op2 = false;
        this.op4 = false;
        this.wxBand = false;
      } else {
        this.op = 0;
        this.op1 = false;
        this.op2 = false;
        this.op4 = false;
      }
    },
    dxFrom() {
      if (this.dx == false) {
        this.dx = true;
        this.txt = "账号密码登录";
        this.op = 0;
        this.type = 2;
        this.sign.psd = "";
      } else {
        this.dx = false;
        this.txt = "短信快捷登录";
        this.type = 1;
        this.sign.psd = "";
      }
    },
    //验证昵称
    regNC() {
      var regs = /^[\w\u4e00-\u9fa5]+$/gi;
      if (this.reg.nickName === undefined) {
        this.op1 = true;
      } else {
        var r = this.reg.nickName.match(regs);
        if (r == null) {
          this.op1 = true;
        } else {
          this.op1 = false;
        }
      }
    },
    //验证手机号
    regPhone() {

    },
    signPhone() {
      var regs = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      if (this.sign.phone === undefined) {
        this.op2 = true;
      } else {
        var r = this.sign.phone.match(regs);
        if (r == null) {
          this.op2 = true;
        } else {
          this.op2 = false;
        }
      }
    },
    //regYzm
    regYzm() {

    },
    signYzm() {

    },
    //验证密码
    regPsd() {
      var regs = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,21}$/;
      if (this.reg.psd === undefined) {
        this.op4 = true;
      } else {
        var r = this.reg.psd.match(regs);
        if (r == null) {
          this.op4 = true;
        } else {
          this.op4 = false;
        }
      }
    },
    signPsd() {
      var regs = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,21}$/;
      if (this.sign.psd === undefined) {
        this.op4 = true;
      } else {
        var r = this.sign.psd.match(regs);
        if (r == null) {
          this.op4 = true;
        } else {
          this.op4 = false;
        }
      }
    },
    //注册
    regist() {
      if (this.reg.nickName === undefined || this.op1 !== false) {
        this.op1 = true;
      }
      if (this.reg.phone === undefined || this.op2 !== false) {
        this.op2 = true;
      }
      // if(this.reg.code === undefined || this.op3 !== false){
      //   this.op3 = true;
      // }
      if (this.reg.psd === undefined || this.op4 !== false) {
        this.op4 = true;
      }
      if (!this.agr) {
        msgError("请认真阅读并勾选已阅读《趣编网用户协议》、《趣编网隐私政策》！");
        return;
      }
      let pam = {
        phone: this.reg.phone,
        code: this.reg.code,
        password: this.reg.psd,
        nickName: this.reg.nickName
      };
      if (
        this.op1 === false &&
        this.op2 === false &&
        this.op4 === false &&
        this.agr === true
      ) {
        apiReg.register(pam).then(data => {
          if (data.status === 1) {
            // window.location.href = 'index.html';
            localStorage.setItem("userInfo", JSON.stringify(data));
            this.jump();
          } else {
            msgError(data.message);
          }
        });
      }
    },
    //登录
    signIn() {
      this.op4 = false;
      if (this.sign.phone === undefined || this.op2 !== false) {
        this.op2 = true;
      }
      if (this.sign.psd === undefined || this.op4 !== false) {
        // this.op3 = true;
        this.op4 = true;
      }
      let pam = {
        phone: this.sign.phone,
        type: this.type,
        pass: this.sign.psd
      };
      if (this.op2 === false && this.op4 === false) {
        apiReg.apiLogin(pam).then(data => {
          if (data.status === 1) {
            console.log(data);
            localStorage.setItem("userInfo", JSON.stringify(data));
            this.jump();
          } else {
            msgError(data.message);
          }
        });
      }
    },
    //判断跳转
    jump() {
      var prevLink = document.referrer;
      var pathname = document.referrer.indexOf('register.html');

      if ($.trim(prevLink) == "" || pathname　!= -1) {
        location.href = "index.html";
      } else {
        location.href = prevLink;
      }
    },
    getBandYzm2(){
      if (this.band.phone === undefined) {
        this.op2 = true;
      } else {
        //发送前验证手机格式
        var regs = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
        var r = this.band.phone.match(regs);
        if (r == null) {
          msgError("号码不正确！");
          return;
        }
        let pam = {
          phone: this.band.phone
        };
        apiReg.apiGetSmsCode_4(pam).then(data => {
          if (data.status == 1) {
            msgSuccess("请注意查收验证码！");
            const TIME_COUNT3 = 59;
            if (!this.timer3) {
              this.count3 = TIME_COUNT3;
              this.show3 = false;
              this.timer3 = setInterval(() => {
                if (this.count3 > 0 && this.count3 <= TIME_COUNT3) {
                  this.count3--;
                } else {
                  this.show3 = true;
                  clearInterval(this.timer3);
                  this.timer3 = null;
                }
              }, 1000);
            }
          } else if (data.status == 0) {
            msgError(data.message);
          }
        });
      }
    },
    goBand(){
      let pam = {
        code:this.band.code,
        phone:this.band.phone
      }
      apiReg.apiWeixinOpenBind(pam).then(data=>{
        console.log(data)
        if(data.status == 1){
          location.href = "index.html";
          localStorage.setItem("userInfo", JSON.stringify(data));
          apiReg.apiWeixinOpenLogin().then();
        }else{
          msgError(data.message);
        }
      });
    },
    //get验证码
    getYzm() {
      if (this.reg.phone === undefined) {
        this.op2 = true;
      } else {
        //发送前验证手机格式
        var regs = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
        var r = this.reg.phone.match(regs);
        if (r == null) {
          msgError("号码不正确！");
          return;
        }
        let pam = {
          phone: this.reg.phone
        };
        apiReg.apiGetSmsCode_3(pam).then(data => {
          if (data.status == 1) {
            msgSuccess("请注意查收验证码！");
            const TIME_COUNT1 = 59;
            if (!this.timer1) {
              this.count1 = TIME_COUNT1;
              this.show1 = false;
              this.timer1 = setInterval(() => {
                if (this.count1 > 0 && this.count1 <= TIME_COUNT1) {
                  this.count1--;
                } else {
                  this.show1 = true;
                  clearInterval(this.timer);
                  this.timer1 = null;
                }
              }, 1000);
            }
          } else if (data.status == 0) {
            msgError(data.message);
          }
        });
      }
    },
    signYzm() {
      if (this.sign.phone === undefined) {
        this.op2 = true;
      } else {
        //发送前验证手机格式
        var regs = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
        var r = this.sign.phone.match(regs);
        if (r == null) {
          msgError("号码不正确！");
          return;
        }
        let pam = {
          phone: this.sign.phone
        };
        apiReg.apiGetSmsCode_4(pam).then(data => {
          if (data.status == 1) {
            msgSuccess("请注意查收验证码！");
            const TIME_COUNT2 = 59;
            if (!this.timer2) {
              this.count2 = TIME_COUNT2;
              this.show2 = false;
              this.timer = setInterval(() => {
                if (this.count2 > 0 && this.count2 <= TIME_COUNT2) {
                  this.count2--;
                } else {
                  this.show2 = true;
                  clearInterval(this.timer2);
                  this.timer2 = null;
                }
              }, 1000);
            }
          } else {
            msgError(data.message);
          }
        });
      }
    }
  },
  mounted(){
    var obj = new WxLogin({
      id:"login_container",
      appid: "wx0f66844ed18e08da",
      scope: "snsapi_login",
      style: "white",
      redirect_uri: "https://www.qvbian.com/qvbian/api/wxOpenRedirect"
    });
  },
  created(){
    if(Util.GetQueryString("mode")){
      this.wxBand = true;
    }
    // if(Util.GetQueryString("mode")){
    //   if(localStorage.getItem("userInfo")){
    //     apiReg.accountWeixinOpenBind().then(data=>{
    //       if(data.status == 1){
    //         location.href = "account.html";
    //       }
    //     });
    //   }else{
    //     location.href = "register.html?mode='true'";
    //   }
    // }
  }
};
</script>

<style scoped>
ul li {
  display: inline-block;
}
/*input:focus{border: 1px solid #D8D8D8;}*/
.logo ul li {
  display: block;
}
.logo ul li img {
  width: 238px;
  /*height: 45px;*/
}
.box {
  overflow: hidden;
  background: url("../../assets/images/reg-bg.jpg") no-repeat;
  height: 100%;
  /* background-size: 100% 100%; */
}
.box .logo,
.box .reg-from {
  /* float: left; */
  position: absolute;
  width: 50%;
  margin: 0;
  height: 100%;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
  left: 50%;
  /* margin-top: 280px; */
}
.box .logo{
  left: 25%;
  transform: translateY(-25%) translateX(-50%);
}
.box .reg-from{
  left: 75%;
}
.reg-from {
  width: 480px !important;
  height: auto !important;
  background: #fff;
  overflow: hidden;
  text-align: center;
  position: relative;
}
.reg-from ul {
  padding: 10px 0px;
}
.reg-from ul li {
  opacity: 0.6;
  font-size: 20px;
  color: #3E87FF;
  padding-bottom: 5px;
  margin: 0 10px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}
.reg-from ul li:hover,
.li-active {
  opacity: 1 !important;
  border-bottom: 2px solid #3E87FF;
}
.from-box {
  width: 320px;
  margin: 0 auto;
  opacity: 1;
  transition: all 1s;
}
.op {
  opacity: 0;
  /*height: 0;*/
  display: none;
}
.from-box input {
  padding-left: 20px;
  font-size: 14px;
  height: 50px;
  color: #424753;
  line-height: 50px;
}
.from-box p {
  text-align: left;
  font-size: 12px;
}
.from-box .from-warning {
  color: #ff5555;
  padding: 10px 0;
  opacity: 0;
}
.op1 {
  opacity: 1 !important;
}
.btn-sign {
  background-image: linear-gradient(90deg, #15b2ff 0%, #3067ec 100%);
  border-radius: 2px;
  width: 100%;
  height: 44px;
  line-height: 44px;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
  letter-spacing: 2px;
}
.other-sign li {
  width: 44px;
  height: 44px;
}
/* .other-sign li:nth-child(1) {
  background: url("../../assets/images/qq.png") no-repeat;
}
.other-sign li:nth-child(2) {
  background: url("../../assets/images/weibo.png") no-repeat;
} */
.other-sign li:nth-child(1) {
  background: url("../../assets/images/wechat.png") no-repeat;
}
.other-sign li:hover {
  border: none !important;
}
/* .other-sign li:nth-child(1):hover {
  background: url("../../assets/images/qq-hover.png") no-repeat;
}
.other-sign li:nth-child(2):hover {
  background: url("../../assets/images/weibo-hover.png") no-repeat;
} */
.other-sign li:nth-child(1):hover {
  background: url("../../assets/images/wechat-hover.png") no-repeat;
}
.yzm-ipt {
  width: 190px !important;
}
.get-yzm {
  width: 110px;
  height: 50px;
  line-height: 50px;
  color: #fff;
  background: #3e87ff;
  float: right;
  text-align: center;
  cursor: pointer;
}
.wx-load-c{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
  z-index: 999;
  text-align: center;
  color: #fff;
}
.wx-load-c *{
  color: #fff !important;
}
.wx-load-c #login_container{
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
  left: 50%;
}
</style>



// WEBPACK FOOTER //
// register.vue?483133dc